import ForgeryProtection from "lib/ForgeryProtection"

// Applies the CSRF token to form fields on CDN-cached pages that have no
// server-rendered token.
//
// The _csrf_fetch_script partial sets window._csrfResolve/Reject to signal those pages.
//
// ForgeryProtection.CSRF only fetches once, so this shares the request with
// addCSRFTokenToAjaxRequests on pages that call both.
if (typeof window._csrfResolve === "function") {
  ForgeryProtection.CSRF.then(({ token }) => {
    document.querySelectorAll('input[name="authenticity_token"]').forEach((el) => {
      el.value = token
    })
    window.csrfTokenApplied = true
    window._csrfResolve()
  }).catch(() => {
    const errorEl = document.getElementById("csrf-fetch-error")
    if (errorEl) errorEl.hidden = false
    window._csrfReject()
  })
}
